/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.WorkshopItemRatingHistory = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The WorkshopItemRatingHistory model module.
   * @module model/WorkshopItemRatingHistory
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>WorkshopItemRatingHistory</code>.
   * @alias module:model/WorkshopItemRatingHistory
   * @class
   */
  var exports = function() {
    var _this = this;




















  };

  /**
   * Constructs a <code>WorkshopItemRatingHistory</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/WorkshopItemRatingHistory} obj Optional instance to populate.
   * @return {module:model/WorkshopItemRatingHistory} The populated <code>WorkshopItemRatingHistory</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Identifier')) {
        obj['Identifier'] = ApiClient.convertToType(data['Identifier'], 'String');
      }
      if (data.hasOwnProperty('ChangeDate')) {
        obj['ChangeDate'] = ApiClient.convertToType(data['ChangeDate'], 'Date');
      }
      if (data.hasOwnProperty('ChangeTypeID')) {
        obj['ChangeTypeID'] = ApiClient.convertToType(data['ChangeTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('ItemRatingID')) {
        obj['ItemRatingID'] = ApiClient.convertToType(data['ItemRatingID'], 'Integer');
      }
      if (data.hasOwnProperty('Created')) {
        obj['Created'] = ApiClient.convertToType(data['Created'], 'Date');
      }
      if (data.hasOwnProperty('CreatorID')) {
        obj['CreatorID'] = ApiClient.convertToType(data['CreatorID'], 'Integer');
      }
      if (data.hasOwnProperty('ParticipantID')) {
        obj['ParticipantID'] = ApiClient.convertToType(data['ParticipantID'], 'Integer');
      }
      if (data.hasOwnProperty('Updated')) {
        obj['Updated'] = ApiClient.convertToType(data['Updated'], 'Date');
      }
      if (data.hasOwnProperty('ItemID')) {
        obj['ItemID'] = ApiClient.convertToType(data['ItemID'], 'Integer');
      }
      if (data.hasOwnProperty('Profitability')) {
        obj['Profitability'] = ApiClient.convertToType(data['Profitability'], 'Number');
      }
      if (data.hasOwnProperty('Effort')) {
        obj['Effort'] = ApiClient.convertToType(data['Effort'], 'Number');
      }
      if (data.hasOwnProperty('RelativeProfitability')) {
        obj['RelativeProfitability'] = ApiClient.convertToType(data['RelativeProfitability'], 'Number');
      }
      if (data.hasOwnProperty('RelativeEffort')) {
        obj['RelativeEffort'] = ApiClient.convertToType(data['RelativeEffort'], 'Number');
      }
      if (data.hasOwnProperty('Score')) {
        obj['Score'] = ApiClient.convertToType(data['Score'], 'Integer');
      }
      if (data.hasOwnProperty('ComparisonDimensionID')) {
        obj['ComparisonDimensionID'] = ApiClient.convertToType(data['ComparisonDimensionID'], 'Integer');
      }
      if (data.hasOwnProperty('ComparisonRating')) {
        obj['ComparisonRating'] = ApiClient.convertToType(data['ComparisonRating'], 'Number');
      }
      if (data.hasOwnProperty('RelativeScore')) {
        obj['RelativeScore'] = ApiClient.convertToType(data['RelativeScore'], 'Integer');
      }
      if (data.hasOwnProperty('WidgetID')) {
        obj['WidgetID'] = ApiClient.convertToType(data['WidgetID'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} Identifier
   * @default ''
   */
  exports.prototype['Identifier'] = '';
  /**
   * @member {Date} ChangeDate
   */
  exports.prototype['ChangeDate'] = undefined;
  /**
   * @member {Integer} ChangeTypeID
   * @default 0
   */
  exports.prototype['ChangeTypeID'] = 0;
  /**
   * @member {Integer} ItemRatingID
   * @default 0
   */
  exports.prototype['ItemRatingID'] = 0;
  /**
   * @member {Date} Created
   */
  exports.prototype['Created'] = undefined;
  /**
   * @member {Integer} CreatorID
   * @default 0
   */
  exports.prototype['CreatorID'] = 0;
  /**
   * @member {Integer} ParticipantID
   */
  exports.prototype['ParticipantID'] = undefined;
  /**
   * @member {Date} Updated
   */
  exports.prototype['Updated'] = undefined;
  /**
   * @member {Integer} ItemID
   * @default 0
   */
  exports.prototype['ItemID'] = 0;
  /**
   * @member {Number} Profitability
   * @default 0.0
   */
  exports.prototype['Profitability'] = 0.0;
  /**
   * @member {Number} Effort
   * @default 0.0
   */
  exports.prototype['Effort'] = 0.0;
  /**
   * @member {Number} RelativeProfitability
   */
  exports.prototype['RelativeProfitability'] = undefined;
  /**
   * @member {Number} RelativeEffort
   */
  exports.prototype['RelativeEffort'] = undefined;
  /**
   * @member {Integer} Score
   * @default 0
   */
  exports.prototype['Score'] = 0;
  /**
   * @member {Integer} ComparisonDimensionID
   */
  exports.prototype['ComparisonDimensionID'] = undefined;
  /**
   * @member {Number} ComparisonRating
   * @default 0.0
   */
  exports.prototype['ComparisonRating'] = 0.0;
  /**
   * @member {Integer} RelativeScore
   */
  exports.prototype['RelativeScore'] = undefined;
  /**
   * @member {Integer} WidgetID
   * @default 0
   */
  exports.prototype['WidgetID'] = 0;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


